import { ApiResponse } from '../../types';
import apiClient from '../api/client';

export interface Province {
  province_code: string;
  name: string;
  id: number;
}

export interface Ward {
  ward_code: string;
  name: string;
  province_code: string;
  id: number;
}

export const locationService = {
  getProvinces: async (): Promise<ApiResponse<Province[]>> => {
    try {
      const response = await apiClient.get<ApiResponse<Province[]>>('/locations/provinces/');
      return response.data;
    } catch (error) {
      console.warn('API call failed:', error);
      return {
        success: false,
        data: [],
      };
    }
  },

  getWards: async (provinceCode: string): Promise<ApiResponse<Ward[]>> => {
    try {
      const response = await apiClient.get<ApiResponse<Ward[]>>('/locations/wards/', {
        params: {
          province_code: provinceCode,
        },
      });
      return response.data;
    } catch (error) {
      console.warn('API call failed:', error);
      return {
        success: false,
        data: [],
      };
    }
  },
};

